<template>
  <div>
    <div class="d-flex mx-auto table-title">
      {{ tableName }}
    </div>
    <div class="card card-custom gutter-b">
      <!--begin::Body-->
      <div class="card-body d-flex flex-column p-0">
        <div
          class="datatable datatable-bordered datatable-head-custom datatable-default datatable-primary datatable-loaded"
        >
          <v-dialog v-model="downloadOrderDialog" width="300px">
            <DownloadDialog @close="downloadDialogClosed"></DownloadDialog>
          </v-dialog>
          <v-data-table
            :height="tableHeight"
            :headers="translatedSelectedColumns"
            fixed-header
            :items="getItems"
            item-key="date"
            :server-items-length="pagesAmount * rowsAmount"
            hide-default-footer
            :options.sync="options"
            :page.sync="page"
            :loading="loading"
            :mobile-breakpoint="1"
            class="text-no-wrap"
            @click:row="rowClick"
          >
            <template v-slot:top="">
              <v-dialog v-model="clicksDialog" max-width="80%">
                <SessionDetailsCard
                  :source-stat="sourceStat"
                  :current-item="row"
                  :show-users="false"
                />
              </v-dialog>
              <v-item-group class="datatable-custom-header">
                <v-container fluid>
                  <div class="d-flex flex-row">
                    <div class="d-flex mx-3 align-center">
                      <v-select
                        v-model="options.itemsPerPage"
                        :items="rows"
                        append-icon="mdi-chevron-down"
                        @change="getTableData()"
                      />
                    </div>
                    <div class="d-flex mx-3 mr-auto">
                      <Pagination
                        v-if="table"
                        :page="options.page"
                        :pages-amount="pagesAmount"
                        v-on:pagechange="options.page = $event"
                      />
                    </div>
                    <div class="d-flex mx-3 align-center">
                      <v-btn
                        v-if="table"
                        @click="getDownloadUrl()"
                        target="_blank"
                        class="px-8 py-6 datatable-header-btn"
                        elevation="0"
                      >
                        {{ $t("export") }}
                      </v-btn>
                    </div>
                    <div class="d-flex mx-3 align-center">
                      <v-select
                        v-model="selectedColumns"
                        :items="dropdownColumns"
                        multiple
                        item-text="text"
                        item-value="value"
                        append-icon="mdi-view-headline"
                        @change="getTableData()"
                      >
                        <template #selection="{ item, index }">
                          <span v-if="index === 0">Customize view</span>
                        </template>
                        <template #prepend-item>
                          <v-list-item ripple @click="selectAllColumns">
                            <v-list-item-action>
                              <v-icon
                                :color="
                                  selectedColumns.length === 0 ? 'primary' : ''
                                "
                              >
                                {{ icon }}
                              </v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title>Select All</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider class="mt-2"></v-divider>
                        </template>
                      </v-select>
                    </div>
                  </div>
                </v-container>
              </v-item-group>
            </template>
            <template v-slot:item.ip="{ item, index }">
              <span class="text-dark-75 d-block font-size-lg">
                <i class="v-icon theme--light"
                  ><img :src="iconSource(item.source_id)" alt=""
                /></i>
                {{ item.ip }}
              </span>
            </template>
            <template v-slot:item.country="{ item }">
              <span class="text-dark-75  d-block font-size-lg">
                {{ item.country }}
              </span>
              <span class="text-muted">
                {{ item.city }}
              </span>
            </template>
            <template v-slot:item.session_id="{ item, index }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    {{ cutSessionId(item.session_id) }}...
                  </span>
                </template>
                <span>{{ item.session_id }}</span>
              </v-tooltip>
            </template>
            <template v-slot:item.ban_type="{ item, index }">
              <span>{{ getBanType(item.ban_type) }}</span>
            </template>
            <template v-slot:item.user_id="{ item, index }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    {{ cutSessionId(item.user_id) }}...
                  </span>
                </template>
                <span>{{ item.user_id }}</span>
              </v-tooltip>
            </template>
            <template v-slot:item.clid="{ item, index }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    {{ cutClid(item.clid) }}...
                  </span>
                </template>
                <span>{{ item.clid }}</span>
              </v-tooltip>
            </template>
            <template v-slot:item.reason="{ item }">
              <Rules_Demo :item="item" />
            </template>
          </v-data-table>
        </div>
      </div>
      <!--end::Body-->
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/_Tables/Pagination";
import Rules_Demo from "@/components/_Tables/Rules_Demo";
import exportTable from "@/core/mixins/exportTable.mixin";
import DownloadDialog from "@/components/_Tables/DownloadDialog";
import SessionDetailsCard from "@/components/_Tables/SessionDetailsCard";

export default {
  name: "DemoTable",
  components: {
    SessionDetailsCard,
    Pagination,
    Rules_Demo,
    DownloadDialog
  },
  mixins: [exportTable],
  props: {
    dates: {
      type: Array,
      required: true
    },
    selectedDomains: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      hitsHistory: [],
      hitsDialog: false,
      clicksDialog: false,
      loadingClicksTable: false,
      row: {},
      sourceStat: {},
      tableName: null,
      loading: false,
      searchQuery: "",
      searchColumn: null,
      rowsAmount: 10,
      sortColumn: null,
      sortDirection: null,
      downloadRequisites: {},
      page: 1,
      pagesAmount: 1,
      searchColumns: [],
      selectedColumns: [],
      availableColumns: [],
      translationColumns: [],
      sortableColumns: [],
      table: null,
      rows: [10, 25, 50, 100],
      timestamp: 0,
      options: {}
    };
  },
  computed: {
    tableHeight() {
      if (this.table && this.table.length > 10) return "550";
      return "auto";
    },
    icon() {
      if (!this.table) return "";
      if (this.availableColumns.length === this.selectedColumns.length)
        return "mdi-checkbox-marked";
      if (this.availableColumns.length !== this.selectedColumns.length)
        return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    translatedColumns() {
      return this.availableColumns?.map(el => ({
        text: this.$t(el),
        value: el
      }));
    },
    translatedSelectedColumns() {
      let columns = [];
      this.selectedColumns.forEach(key => {
        columns.push({
          text: this.translationColumns[key],
          value: key,
          sortable: this.sortableColumns.includes(key)
        });
      });
      columns = columns?.filter(
        el =>
          el.value != "source_id" &&
          el.value != "city" &&
          el.value != "source_type"
      );
      return columns;
    },
    getItems() {
      return this.table || [];
    },
    dropdownColumns() {
      let columns = [];
      this.availableColumns.forEach(key => {
        columns.push({
          text: this.translationColumns[key],
          value: key
        });
      });
      return columns;
    }
  },
  watch: {
    options: {
      async handler() {
        await this.getTableData();
      }
    },
    async dates() {
      await this.getTableData();
    },
    async selectedDomains() {
      await this.getTableData();
    }
  },
  methods: {
    getBanType(banType) {
      switch (banType) {
        case 1:
          return "by IP";

        case 2:
          return "by Placement";

        case 3:
          return "by Range";

        case 4:
          return "by User";
      }
    },
    async rowClick(item) {
      this.row = item;
      this.clicksDialog = true;

      let source = null;

      switch (item.ban_type) {
        case 1:
          source = item.ip;
          break;

        case 2:
          source = item.placement;
          break;

        case 3:
          break;

        case 4:
          source = item.user_id;
          break;
      }

      try {
        const { data } = await this.$api.analyticsBlocking.getSourceStat({
          source: source,
          sourceId: item.source_id,
          sourceTypeId: item.ban_type,
          dateFrom: this.dates[0],
          dateTo: this.dates[1] ?? this.dates[0],
          domainId: this.selectedDomains.map(el => el.id).shift()
        });
        this.sourceStat = data;
        this.sourceStat.source = source;
      } catch (e) {
        switch (e.response.status) {
          case 401: {
            await this.$api.auth.logout();
          }
        }
      } finally {
        this.loadingClicksTable = false;
      }
    },
    cutSessionId(string) {
      let parts = string.split("-");
      return parts[0];
    },
    cutClid(string) {
      if (string.length < 10) {
        return string;
      }
      return string.substr(0, 10);
    },
    iconSource(source_id) {
      if (source_id === 1) return "/pages/sources/icons-google.svg";
      if (source_id === 2) return "/pages/sources/icons-yandex.svg";
      return "";
    },
    async getTableData() {
      this.loading = true;

      if (!this.selectedDomains.length) {
        return;
      }
      if (!this.options.page) {
        this.options.page = 1;
      }
      try {
        const {
          downloadRequisites,
          pagesAmount,
          searchColumns,
          visibleColumns,
          availableColumns,
          translations,
          sortableColumns,
          table,
          timestamp,
          name
        } = await this.$api.demo.getTable({
          dateFrom: this.dates[0],
          dateTo: this.dates[1] ?? this.dates[0],
          domains: this.selectedDomains.map(el => el.id),
          searchQuery: this.searchQuery,
          rowsAmount: this.options.itemsPerPage,
          searchColumn: this.searchColumn,
          selectedColumns: this.selectedColumns,
          page: this.options.page,
          sortColumn: this.options.sortBy[0],
          sortDirection:
            this.options.sortDesc[0] === false
              ? "asc"
              : this.options.sortDesc[0] === true
              ? "desc"
              : null,
          tableName: "demoTable"
        });
        if (timestamp > this.timestamp) {
          this.downloadRequisites = downloadRequisites;
          this.pagesAmount = pagesAmount;
          this.searchColumns = searchColumns;
          this.selectedColumns = visibleColumns;
          this.availableColumns = availableColumns;
          this.translationColumns = translations;
          this.sortableColumns = sortableColumns;
          this.table = table;
          this.timestamp = timestamp;
          this.tableName = name;
        }
      } catch (e) {
        switch (e.response.status) {
          case 401: {
            await this.$api.auth.logout();
          }
        }
      } finally {
        this.loading = false;
      }
    },
    async selectAllColumns() {
      if (this.selectedColumns.length === this.availableColumns.length) {
        this.selectedColumns = [];
      } else {
        this.selectedColumns = this.availableColumns;
      }
      await this.getTableData();
    }
  }
};
</script>

<style>
.v-progress-linear__background {
  background: #1867c0 !important;
}
.v-progress-linear__indeterminate {
  background: #1867c0 !important;
}
.table-title {
  color: #131212;
  font-size: 1.55rem;
  line-height: 3rem;
  text-align: center;
  margin-bottom: 0.5em;
}
.history-time {
  font-weight: 400;
  font-size: 1.1em;
}
.history-date {
  font-weight: normal;
  color: rgba(0, 0, 0, 0.6);
}
.theme--light.v-select .v-select__selections {
  color: white !important;
}
</style>
